// extracted by mini-css-extract-plugin
export default {"root":"styles_root__UVojc","container":"styles_container__exOB7","label":"styles_label__7auKb","select":"styles_select__lvz+4"};